import Modal, { IModalProps } from "@/component/Modal";
import fridayReporter from "@/utils/friday";
import { message } from "antd";
import ReactDOM from "react-dom/client";
import CloseIcon from "@/assets/common/ic_modal_close.svg?react";
import "./index.less";
import OperBtns from "./OperBtns";
import PasswordInput from "./PasswordInput";
import PermissionScopeSelect from "./PermissionScopeSelect";
import IconAddMember from "@/assets/record/ic_add_member.svg?react";
import ArrowRightIcon from "@/assets/common/ic_arrow_right.svg?react";
import SharerList from "./SharerList";
import SettingPanel from "./SettingPanel";
import QrCodePanel from "./QrCodePanel";
import { openStaffAddModal } from "./StaffAddModal";
import useGetShareSetting from "@/sections/Share/useGetShareSetting";
import { useEffect } from "react";
import summaryCommonStore from "@/store/summaryCommon.store";
import LinkValidityRefreshBtn from "./LinkValidityRefreshBtn";

interface ShareInfo {
  streamName: string;
  title: string;
}
export interface IShareModal extends Pick<IModalProps, "visible" | "onClose"> {
  streamName: string;
  title?: string;
}

const ShareModal: React.FC<IShareModal> = ({
  visible,
  onClose,
  title,
  streamName,
}) => {
  const {
    editable,
    isCompany,
    isPassWord,
    shareSetting,
    shareInfo,
    mySharePermission,
    updateShareScope,
    updatePassword,
    onShareSettingChange,
    handleError,
    panel,
    setPanel,
    sharerList,
    setSharerList,
    refreshSharerList,
  } = useGetShareSetting(streamName);

  const showCompanyError = summaryCommonStore((state) => state.showCompanyError);

  useEffect(() => {
    if(showCompanyError) {
      onClose();
    }
  }, [showCompanyError, onClose])
  

  const handleCopyUrl = () => {
    fridayReporter.pushData({
      eventCode: "SummaryPage_Share_Copylink",
    });
    if(!shareInfo?.url){
      message.error("链接不存在，无法复制");
      return;
    }
    const text = `${shareInfo.url} 《${title}》${
      isPassWord ? `密码：${shareSetting.password}` : ""
    }`;
    if(navigator?.clipboard){
      navigator?.clipboard?.writeText(
        text
      );
    } else {
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
    
    message.success("复制成功");
  };

  const handleShowDefaultPanel = () => {
    setPanel("default");
    refreshSharerList();
  };

  const handleShowQrCode = () => {
    setPanel("qrcode");
  };

  const handleShowSettingPanel = () => {
    setPanel("setting");
  };

  const handleShowStaffAddModal = () => {
    if (shareInfo?.shareId) {
      openStaffAddModal({
        shareId: shareInfo.shareId,
        mySharePermission,
        onCloseCb: handleShowDefaultPanel,
        handleError,
      });
      setPanel("");
    }
  };

  return (
    <Modal visible={visible} onClose={onClose} mask maskClosable={true}>
      <div className="flex flex-col bg-white w-80 h-120 rounded-2.5 shadow relative overflow-x-hidden overflow-y-hidden">
        {panel === "default" && (
          <>
            <div className="px-4 b-1px b-b-solid b-#DBDEE4">
              <div className="flex items-center h-12 w-full">
                <div className="text-4 font-500 text-mx-secondary">分享</div>
                <CloseIcon
                  className="block absolute right-3 top-3 size-6 cursor-pointer"
                  onClick={onClose}
                />
              </div>
              <div className="flex items-center justify-between text-3 h-6 mt-1 text-mx-tertiary">
                <div>分享范围</div>
                {editable && (
                  <div
                    className="flex items-center cursor-pointer"
                    onClick={handleShowSettingPanel}
                  >
                    安全设置
                    <ArrowRightIcon className="pl-1 size-4" />
                  </div>
                )}
              </div>
              <div className="flex flex-col items-center justify-center mt-2">
                <div className="w-full b-1px b-solid b-#DBDEE4 rd-2 flex items-center">
                  <div className="flex-1">
                    <PermissionScopeSelect
                      permissionChoose={shareSetting.shareScope}
                      setPermissionChoose={updateShareScope}
                      disabled={!editable}
                      isCompany={isCompany}
                    />
                  </div>
                  {isCompany && (
                    <div
                      className="w-10 h-10 b-1px b-l-solid b-#DBDEE4 flex items-center justify-center cursor-pointer"
                      onClick={handleShowStaffAddModal}
                    >
                      <IconAddMember />
                    </div>
                  )}
                </div>

                <PasswordInput
                  isPassWord={isPassWord}
                  password={shareSetting.password}
                  disabled={!editable}
                  setPassword={updatePassword}
                />
                <LinkValidityRefreshBtn
                  shareInfo={shareInfo}
                  disabled={!editable}
                  onShareSettingChange={onShareSettingChange}
                />
                <OperBtns
                  isPassWord={isPassWord}
                  disabled={!shareInfo?.url}
                  handleCopyUrl={handleCopyUrl}
                  handleShowQrCode={handleShowQrCode}
                />
              </div>
            </div>
            {shareInfo?.shareId && (
              <SharerList
                shareId={shareInfo?.shareId}
                mySharePermission={mySharePermission}
                handleError={handleError}
                sharerList={sharerList}
                setSharerList={setSharerList}
              />
            )}
          </>
        )}
        {panel === "setting" && (
          <SettingPanel
            onClose={onClose}
            onBack={handleShowDefaultPanel}
            shareSetting={shareSetting}
            expiredTime={shareInfo?.expiredTime}
            onShareSettingChange={onShareSettingChange}
          />
        )}
        {panel === "qrcode" && (
          <QrCodePanel
            shareUrl={shareInfo?.url}
            onClose={onClose}
            onBack={handleShowDefaultPanel}
          />
        )}
      </div>
    </Modal>
  );
};

export const openShareModalV2 = (info: ShareInfo) => {
  console.log("openShareModalV2", info);
  const root = document.getElementById("root");
  const div = document.createElement("div");
  root?.appendChild(div);
  const close = () => {
    root?.removeChild(div);
  };
  const modal = <ShareModal visible onClose={close} {...info} />;
  ReactDOM.createRoot(div).render(modal);
};

export default ShareModal;
